<template>
    <el-drawer
        title="会员详情"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <template v-if="data">
				<div>
					<table class="info-table" style="width:100%">
						<tr>
							<td v-if="data && data.avatar"><el-image :src="data.avatar | coverImage(100,100)" fit="cover" :preview-src-list="[data.avatar]"
                			    style="width:80px;height:80px;"></el-image></td>
							<td style="margin: 0; padding: 0; border: none;">
								<table class="info-table">
									<tr>
										<th><span class="color-info">用户昵称: </span></th>
										<td>{{data.userName}}</td>
										<th><span class="color-info">会员状态: </span></th>
										<td>{{data.statusView}}</td>
									</tr>
									<tr>
										<th><span class="color-info">首次开通时间: </span></th>
										<td>{{data.firstBuyTime}}</td>
										<th><span class="color-info">会员过期时间: </span></th>
										<td>{{ data.expireTime }}</td>
									</tr>
									<tr>
										<th><span class="color-info">闪付授权次数: </span></th>
										<td>{{ data.quickPayAuthNum }}</td>
										<th><span class="color-info">闪付使用次数: </span></th>
										<td>{{ data.quickPayUseNum}}</td>
									</tr>
									<tr>
										<th> <span class="color-info">闪付消费金额: </span></th>
										<td>{{ data.quickPayCost}}</td>
										<th><span class="color-info">定时购免积分使用次数: </span></th>
										<td>{{ data.preBuyUseNum }}</td>
									</tr>
									<tr>										
										<th><span class="color-info">邀请券领取次数: </span></th>
										<td>{{ data.inviteGetNum }}</td>
										<th></th>
										<td></td>
									</tr>
									<tr>
										<td colspan="4">
											<template v-if="data.userType==1">												
												<el-link class="color-blue" target="_blank" :href="`/user/fans/edit/${data.userId}`" >查看用户详情信息></el-link>
											</template>
											<template v-if="data.userType==2">
												<el-link class="color-blue" target="_blank" :href="`/user/artist/edit/baseInfo/${data.userId}`" >查看用户详情信息></el-link>
											</template>
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</table>
				</div>
                
			</template>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">关闭</el-button>
            
        </div>
    </el-drawer>
</template>
<script>

export default {
   
    data(){
        
        return{
            drawerShow: false,
            btnLoading: false,
			pageLoading:false,
			id:'',
			data:null
           
        }
    },
    methods:{
        close(){
            this.drawerShow = false
			this.data = null
        },
        show(id){            
            this.drawerShow = true;
			this.id = id
			if( this.id ){
				this.getInfo()
			}
        },
        //获取详情
        getInfo(){
            this.pageLoading = true;
            this.$request({
                url: '/member/detail',
                method: "POST",
                params: {userId:this.id}
            }).then(res=>{
                const {state, msg, result} = res.data;
                if (state == 1) {
                    this.data = result
        			
                } else {
                    this.$message.error(msg || "请求失败");
                }
            }).catch(() => {
                this.$message.error("请求错误");
            }).finally(()=>{
                this.pageLoading = false;
            })
        },
		toDetails(data){
			if( data.userType === 1 ){
				// /user/fans/edit/22607586
			}
		}
    }
}
</script>

<style lang="scss" scoped>
.info-table td {
		border-right: 1px solid #eee;
		padding-left:20px;
	}
	.info-table th {
		padding-left:20px;
	}
.color-info{
	cursor: pointer;
	span{
		color:#000
	}
}
.color-info:hover{
	color:#409EFF
}
::v-deep .el-link.el-link--default{
	color:#409EFF
}
::v-deep .el-link.el-link--default:hover{
	color:#1fbb7d
}
</style>